export class AppConfigurationsModel {
  id: number;
  keyName: string;
  isEnabled: boolean;
  templateId: number;
  regionIdId: number;
  calendarId: number;
}
